import { Component, OnInit } from '@angular/core';
import { ConductListTableConfig } from "./conduct-list.table-config";
import { BrokerAdminService, ClientService, ConductService, LocalStorageService, SurveyService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
import { Router } from '@angular/router';
import { APP_ROUTES, USER_ROLES } from '@app/constants';
import { AppNotification } from '@app/helpers';
@Component({
  selector: 'app-conduct-list',
  templateUrl: './conduct-list.component.html',
  styleUrls: ['./conduct-list.component.scss']
})
export class ConductListComponent implements OnInit {
  panelVisible: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  surveyList: any = []
  clientList: any = []
  editSelected: any;
  selectedSurvey: string | null;
  selectedClient: string | null;

  surveyClientSelectPopup: boolean = false;

  alertFormDuplicate: any = {
    selected: null,
    visible: false
  }

  constructor(
    private conductService: ConductService,
    private surveyService: SurveyService,
    private clientService: ClientService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.config = ConductListTableConfig.configure();
    this.getList();
  }

  getList() {
    this.isLoading = true;
    this.conductService.list(null, null, true).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.dataSource = res.data
        this.dataSource.forEach((el: any) => {
          el.archived = el.archived ? 'Archived' : ''
          el.userName = `${el.client?.user.firstName || ""} ${el.client?.user.lastName || ""}`
          el.creactedByName = `${el.createdBy?.firstName || ""} ${el.createdBy?.lastName || ""}`
        });
        console.log(this.dataSource)
      }
    })
  }

  getSurveyList() {
    this.surveyService.list().subscribe({
      next: (res: any) => {
        this.surveyList = res.data
      }
    })
  }

  getClientList() {
    this.clientService.list().subscribe({
      next: (res: any) => {
        res.data.forEach((o: any) => {
          o.name = `${o.user?.firstName ?? ""} ${o.user?.lastName ?? ""} ${ o.tradingName ? "- " + o.tradingName : ""}`
        })
        this.clientList = res.data
      }
    })
  }

  action(e: any) {
    if (e.button.eventName == "details") {
      this.router.navigate([
        APP_ROUTES.CONDUCT_DETAILS
      ], {
        queryParams: {
          conductId: e.data._id
        }
      });
    }
    if (e.button.eventName == "add") {
      this.surveyClientSelectPopup = true
      this.getSurveyList()
      this.getClientList()
    }
    if (e.button.eventName == "copy") {
      this.confirmDuplication(e.data);
      console.log(e);
    }
  }

  cloneConduct(sourceConduct: any) {
    return this.conductService.duplicate(sourceConduct._id).subscribe({
      next: (res: any) => {
        AppNotification.success('Cloned!')
        this.getList();
      },
      error: () => {
        AppNotification.error('Some error occured!')
      }
    })
  }

  proceedToConduct() {
    if (this.selectedSurvey == null || this.selectedClient == null) {
      return
    }
    this.router.navigate([
      APP_ROUTES.CONDUCT_DETAILS
    ], {
      queryParams: {
        surveyId: this.selectedSurvey,
        clientId: this.selectedClient
      }
    });
  }

  confirmDuplication(survey: any) {
    this.alertFormDuplicate = {
      selected: survey,
      visible: true
    }
  }

}
